import type { PatentProfileWithMatchedTechFeature } from '../types';

export interface FtoReportSimilarRepository {
    updateNoveltySimilarList(taskId: string, techFeatures: PatentProfileWithMatchedTechFeature[]): Promise<PatentProfileWithMatchedTechFeature[]>;

    getFeatureComparison(taskId: string, pns: string[]): Promise<PatentProfileWithMatchedTechFeature[]>;
}

export const FtoReportSimilarRepository = Symbol.for('FtoReportSimilarRepository');
